<template>
  <div class="pay-result-wrap">
    <div class="pay-result-box">

      <!-- 처리 중 -->
      <div v-if="status === 'processing'">
        <div class="spinner"></div>
        <p class="status-msg">{{ statusMsg }}</p>
      </div>

      <!-- 예약 확정 -->
      <div v-else-if="status === 'success'">
        <div class="result-icon">🎉</div>
        <h2>예약이 확정되었습니다!</h2>
        <div class="result-info">
          <div class="ri-row">
            <span>예약번호</span>
            <strong>{{ bookingNo }}</strong>
          </div>
          <div class="ri-row">
            <span>호텔명</span>
            <strong>{{ hotelName }}</strong>
          </div>
          <div class="ri-row">
            <span>체크인</span>
            <strong>{{ checkIn }}</strong>
          </div>
          <div class="ri-row">
            <span>체크아웃</span>
            <strong>{{ checkOut }}</strong>
          </div>
          <div class="ri-row">
            <span>결제금액</span>
            <strong>{{ krw(amount) }}원</strong>
          </div>
        </div>
        <button @click="goToMain" class="btn-main">메인으로 →</button>
      </div>

      <!-- 공급사 확인 대기 -->
      <div v-else-if="status === 'pending'">
        <div class="result-icon">⏳</div>
        <h2>예약 확인 중입니다</h2>
        <p class="sub-msg">공급사 확인 중입니다.<br>수 분에서 수 시간 소요될 수 있습니다.</p>
        <div class="result-info">
          <div class="ri-row">
            <span>예약번호</span>
            <strong>{{ bookingNo }}</strong>
          </div>
          <div class="ri-row">
            <span>호텔명</span>
            <strong>{{ hotelName }}</strong>
          </div>
          <div class="ri-row">
            <span>체크인</span>
            <strong>{{ checkIn }}</strong>
          </div>
          <div class="ri-row">
            <span>체크아웃</span>
            <strong>{{ checkOut }}</strong>
          </div>
        </div>
        <p class="contact-msg">확정 후 이메일로 안내드립니다.<br>문의: 1660-4602</p>
        <button @click="goToMain" class="btn-main">메인으로 →</button>
      </div>

      <!-- 예약 실패 (결제 자동환불) -->
      <div v-else-if="status === 'failed'">
        <div class="result-icon">❌</div>
        <h2>예약에 실패했습니다</h2>
        <p class="error-msg">{{ errorMsg }}</p>
        <p class="refund-notice">💳 결제금액은 자동으로 환불 처리됩니다.</p>
        <p class="contact-msg">문의: 1660-4602</p>
        <button @click="goToMain" class="btn-main">메인으로 →</button>
      </div>

    </div>
  </div>
</template>

<script>
import { handlerInfo } from '../assets/js/commonFunctions';         // 알림톡발송대상추출
export default {
  name: 'RtxSuccess_pg',

  data() {
    return {
      status:    'processing',
      statusMsg: '결제를 확인하는 중...',
      errorMsg:  '',

      bookingNo: '',
      bookingId: '',
      hotelName: '',
      checkIn:   '',
      checkOut:  '',
      amount:    0,

      pollTimer: null,
      pollCount: 0,

      // 자동환불용 paymentKey 보관
      paymentKey: '',

      handTel: [],   // 알림톡 발송대상배열

      bookingData: null,
    };
  },

  async mounted() {
    // ← 임시 확인용
    //console.log('[Toss redirect params]', JSON.stringify(this.$route.query))

    // 알림톡 발송대상(handlerInfo) 추출
    this.getHandlerInfo();    

    // ① 토스 리다이렉트 파라미터 수신
    const { paymentKey, orderId, amount } = this.$route.query;

    if (!paymentKey || !orderId || !amount) 
    {
      this.setFailed('결제 정보가 올바르지 않습니다.');
      return;
    }

    this.paymentKey = paymentKey;

    // ② sessionStorage에서 예약 데이터 복원(예약정보전체)
    const raw = sessionStorage.getItem('hotelBookingData');
    if (!raw) 
    {
      this.setFailed('예약 정보를 찾을 수 없습니다. 다시 시도해주세요.');
      return;
    }

    const bookingData = JSON.parse(raw);
    this.bookingData = bookingData;

    // ③ 금액 위변조 검증
    if (Number(amount) !== Number(bookingData.selling_krw)) 
    {
      this.setFailed('결제 금액이 일치하지 않습니다. 문의: 1660-4602');
      return;
    } 

    this.amount    = Number(amount);
    this.bookingNo = orderId;
    this.hotelName = bookingData.hotel_name || '';
    this.checkIn   = bookingData.check_in   || '';
    this.checkOut  = bookingData.check_out  || '';

    // ④ 토스 결제 승인
    this.statusMsg = '결제를 승인하는 중...';
    try 
    {
      const confirmResult = await this.$api('/api/tossPG/hotelSuccess', {
        param: [{ paymentKey, orderId, amount: Number(amount) }]
      });

      if (!confirmResult || confirmResult.status !== 'DONE') 
      {
        throw new Error('결제 승인에 실패했습니다.');
      }

      // ✅ 결제완료(PY) 알림톡 발송 (발송실패해도 예약 진행에 영향 없음)
      this.sendKakaoHotelPay('PY', bookingData)
    } 
    catch (e) 
    {
      console.error('[RtxSuccess_pg] 결제승인 오류:', e);
      this.setFailed('결제 승인에 실패했습니다. 문의: 1660-4602');
      return;
    }

    // ⑤ PostPreBook + DB 저장
    this.statusMsg = '예약 정보를 등록하는 중...';
    let preBookResult;
    try 
    {
      preBookResult = await this.$api('/api/rtx/postPreBook', {
        param: [{ ...bookingData }]
      });
      
      if (!preBookResult.success) 
      {
        throw new Error(preBookResult.message || 'PreBook 실패');
      }

      this.bookingId = preBookResult.booking_id;
      // this.bookingNo = preBookResult.booking_no;
    } 
    catch (e) 
    {
      console.error('[RtxSuccess_pg] PreBook 오류:', e);
      await this.cancelPayment('예약 처리 실패');

      // 결제취소 알림톡 PCX (예약 없이 결제만 취소된 경우)
      this.sendKakaoHotelPay('PCX', bookingData);
      
      sessionStorage.removeItem('hotelBookingData')                       // 실패 -> 세션스토리지 삭제
      this.setFailed('예약 처리에 실패했습니다. 결제는 자동으로 환불됩니다.');
      return;
    }

    // 결제정보저장(실패해도 프로세스는 진행)
    try 
    {
      const reqPayResult = await this.$api('/api/saveHotelReqPay', {
        param: [
          this.bookingNo,                      // 1: reqPayCode
          this.amount,                         // 2: reqPayAmount
          bookingData.contact_email || '',     // 3: paidId
          this.amount,                         // 4: actualPayAmount
          this.amount,                         // 5: reqTotPayAmt
          bookingData.contact_email || '',     // 6: insId
          paymentKey,                          // 7: payment_key
          this.amount,                         // 8: p1PayAmt
        ]
      });

      if (!reqPayResult || reqPayResult.affectedRows < 1) 
      {
        console.error('[RtxSuccess_pg] 결제정보 저장 실패:', this.bookingNo);
      }
    } 
    catch (e) 
    {
      // 저장 실패해도 예약 진행 유지
      console.error('[RtxSuccess_pg] 결제정보 저장 오류:', e);
    }

    // ⑥ PostBook
    this.statusMsg = '예약을 생성하는 중...';
    try 
    {
      const bookResult = await this.$api('/api/rtx/postBook', {
        param: [{ booking_id: this.bookingId, session_id: bookingData.session_id }]
      });

      if (!bookResult.success) 
      {
        throw new Error(bookResult.message || 'PostBook 실패');
      }

      // ⑦ 폴링 시작
      this.statusMsg = '예약 확정을 기다리는 중...';
      this.startPoll(bookingData.session_id);

    } 
    catch (e) 
    {
      console.error('[RtxSuccess_pg] PostBook 오류:', e);
      await this.cancelPayment('예약 생성 실패');
      this.sendKakaoHotelPay('PCX', this.bookingData);     // 결제취소 알림톡 발송
      sessionStorage.removeItem('hotelBookingData')       // 실패시 세션스토리지 삭제
      this.setFailed('예약 생성에 실패했습니다. 결제는 자동으로 환불됩니다.');
    }
  },

  beforeUnmount() {
    this.stopPoll();
  },

  methods: {
    // 담당직원 연락처
    async getHandlerInfo() {
      let handTel = await handlerInfo(this.$api)
      if (handTel.length > 0) this.handTel = handTel
    },

    // ── 호텔 알림톡 통합 발송 (PY / CO / CX) ────────────────────
    // param    : 'PY' 결제완료 | 'CO' 예약확정 | 'CX' 취소
    // cancelFee: CX일 때 취소수수료 (기본 0)
    // refundAmt: CX일 때 환불금액 (기본 selling_krw 전액)
    sendKakaoHotelPay(param, bookingData, cancelFee = 0, refundAmt = null) {
      const bd = bookingData;
      if (!bd) return;

      let stayDateRange = `${bd.check_in} ~ ${bd.check_out}`;
      let paxCnt        = `대인: ${bd.adult_count || 0} / 소인: ${bd.children?.length || 0}`;
      let today         = new Date().toISOString().slice(0, 10);
      let payAmount = (param === 'CX' || param === 'PCX')   // 예약취소 또는 결제취소
          ? this.krw(refundAmt ?? bd.selling_krw) + '원'
          : this.krw(this.amount) + '원';

      // 담당직원 + 고객
      let sendTargets = [
        ...this.handTel.map(h => ({ callNo: h.aimCall, callName: h.handlerName ?? '담당자' })),
        { callNo: bd.contact_no || '', callName: bd.contact_name || '' }
      ];

      const promises = sendTargets.map(target => {
        const kakaoAlimData = {
          alimFlag    : param,                             // PY / CO / CX
          clientCall  : target.callNo,                     // 수신자 콜번
          clientName  : target.callName,                   // 수신자명
          rtxName     : bd.hotel_name,                     // 숙박업소 (PY/CO/CX 공통 - 백엔드에서 resName도 rtxName으로 처리)
          resPaxName  : bd.contact_name,                   // 예약자명
          resPaxCnt   : paxCnt,                            // 투숙인원
          resRoom     : bd.room_count,                     // 투숙객실수
          resStayDate : stayDateRange,                     // 숙박일자
          resPhone    : bd.contact_no,                     // 연락번호
          resCode     : this.bookingNo,                    // 예약번호
          resPayAmount: payAmount,                         // 결제금액(PY/CO) or 환불금액(CX)
          hotel_tel   : bd.hotel_tel || '',                // 숙소연락처 → 백엔드 rtxPhone
          memFlag: bd.mem_flag || (this.$store.state.user?.email ? 'Y' : 'N'),      // 회원여부(Y/N) → 백엔드 memFlag
          // CX 전용
          resDate     : today,                             // 취소일자
          resFeeAmount: this.krw(cancelFee) + '원',        // 취소수수료
        };
        return this.$api('api/kakaoAlimSend10', { param: [{ kakaoAlimData }] })
          .catch(e => console.error(`[${param} 알림톡 실패]`, target.callNo, e));
      });

      Promise.all(promises).then(() => {
        console.log(`[${param} 알림톡 발송 완료]`);
      });
    },

    // ── 폴링 ──────────────────────────────
    startPoll(sessionId) {
      this.pollCount = 0;

      const poll = async () => {
        this.pollCount++;
        try 
        {
          const result = await this.$api('/api/rtx/getBookStatus', {
            param: [{ booking_id: this.bookingId, session_id: sessionId }]
          });

          if (result.success) 
          {
            const s = result.status;

            if (s === 'bkg-cf') 
            {
              // ✅ 확정 → CO 업데이트
              try 
              {
                await this.$api('/api/updateHotelReqPayStatus', {
                  param: ['CO', this.bookingNo]
                });
              } 
              catch (e) 
              {
                console.error('[RtxSuccess_pg] 상태업데이트(CO) 오류:', e);
              }
              sessionStorage.removeItem('hotelBookingData');
              this.sendKakaoHotelPay('CO', this.bookingData);         // 확정 알림톡 발송
              this.stopPoll();
              this.status = 'success';
              return;
            }
            else if (s === 'bkg-af') 
            {
              // ✅ 실패 → RF 취소환불
              try 
              {
                await this.$api('/api/updateHotelReqPayStatus', {
                  param: ['RF', this.bookingNo]
                });
              } 
              catch (e) 
              {
                console.error('[RtxSuccess_pg] 상태업데이트(RF) 오류:', e);
              }
              this.stopPoll();
              await this.cancelPayment('예약 확정 실패');
              this.sendKakaoHotelPay('CX', this.bookingData);         // 결제취소알림발송
              sessionStorage.removeItem('hotelBookingData');
              this.setFailed('예약 확정에 실패했습니다. 결제는 자동으로 환불됩니다.');
              return;
            }
            else if (s === 'bkg-ps') 
            {
              // ✅ 공급사 대기 → PS 업데이트
              try 
              {
                await this.$api('/api/updateHotelReqPayStatus', {
                  param: ['PS', this.bookingNo]
                });
              } 
              catch (e) 
              {
                console.error('[RtxSuccess_pg] 상태업데이트(PS) 오류:', e);
              }
              sessionStorage.removeItem('hotelBookingData');
              this.status = 'pending';
              // this.stopPoll();       // 계속 폴링 유지 (공급사 확인 후 CO/RF로 상태 변경)
              // return;
            }
          }
        } 
        catch (e) 
        {
          console.error('[RtxSuccess_pg] 폴링 오류:', e);
        }

        let interval = 5000;
        if (this.pollCount > 12) interval = 30000;
        this.pollTimer = setTimeout(poll, interval);
      };

      this.pollTimer = setTimeout(poll, 5000);
    },

    stopPoll() {
      if (this.pollTimer) 
      {
        clearTimeout(this.pollTimer);
        this.pollTimer = null;
      }
    },

    // ── 결제 취소 (자동환불) ──────────────
    async cancelPayment(reason) {
      try 
      {
        // ① Toss 환불
        await this.$api('/api/tossPG/hotelCancel', { 
          param: [{ paymentKey  : this.paymentKey, cancelReason: reason }]
        });
        console.log('[RtxSuccess_pg] Toss 환불 완료');
  
        // ② DB 업데이트 (예약상태 bkg-cx, 결제상태 CX)
        await this.$api('/api/cancelHotelBooking_no', { param: [this.bookingNo] });
        console.log('[RtxSuccess_pg] 예약마스터 취소처리완료');

        // ③ tb_reqpay → CX
        await this.$api('/api/updateHotelReqPayStatus', {
          param: ['CX', this.bookingNo]
        });

        console.log('[RtxSuccess_pg] 예약결제정보 취소처리완료');
      } 
      catch (e) 
      {
        console.error('[RtxSuccess_pg] 자동환불 실패:', e);
      }
    },

    // ── 실패 처리 ──────────────────────────
    setFailed(msg) {
      this.stopPoll();
      this.errorMsg = msg;
      this.status   = 'failed';
    },

    // ── 유틸 ───────────────────────────────
    krw(val) {
      // 자바스크립트 내장함수
      if (!val) return 0;
      return new Intl.NumberFormat('ko-KR').format(val);
    },

    goToMain() {
      this.$router.push({ path: '/' });
    }
  }
};
</script>

<style scoped>
.pay-result-wrap {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 16px;
  font-family: 'Noto Sans KR', sans-serif;
}

.pay-result-box {
  width: 100%;
  max-width: 480px;
  background: #fff;
  border-radius: 16px;
  padding: 40px 32px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.1);
  text-align: center;
}

/* 처리중 */
.spinner {
  width: 48px; height: 48px; margin: 0 auto 20px;
  border: 4px solid #eee; border-top-color: #1a6eb5;
  border-radius: 50%; animation: spin 0.8s linear infinite;
}
.status-msg { font-size: 15px; color: #666; }

/* 공통 */
.result-icon { font-size: 56px; margin-bottom: 16px; }

h2 {
  font-size: 20px; font-weight: 800;
  color: #1a1a2e; margin-bottom: 20px;
}

.result-info {
  background: #f8f9ff;
  border-radius: 10px;
  padding: 16px;
  margin: 20px 0;
  text-align: left;
}
.ri-row {
  display: flex;
  justify-content: space-between;
  padding: 7px 0;
  font-size: 14px;
  color: #555;
  border-bottom: 1px solid #eee;
}
.ri-row:last-child { border-bottom: none; }
.ri-row strong { color: #1a1a2e; font-weight: 700; }

/* 성공 */
.result-success h2 { color: #276749; }

/* 대기 */
.sub-msg {
  font-size: 14px; color: #888;
  line-height: 1.7; margin-bottom: 16px;
}

/* 실패 */
.error-msg {
  font-size: 14px; color: #888;
  margin-bottom: 8px; line-height: 1.6;
}
.refund-notice {
  font-size: 14px; color: #1a6eb5;
  font-weight: 700; margin: 12px 0 8px;
}
.contact-msg {
  font-size: 13px; color: #aaa;
  margin-top: 8px;
}

/* 버튼 */
.btn-main {
  width: 100%; padding: 13px; margin-top: 8px;
  background: #1a6eb5; color: #fff;
  border: none; border-radius: 8px;
  font-size: 15px; font-weight: 700;
  cursor: pointer; transition: background 0.2s;
}
.btn-main:hover { background: #86cd53; }

@keyframes spin { to { transform: rotate(360deg); } }
</style>